import path from 'ramda/src/path'
import convertUnitToMap from 'helpers/convertUnitToMap'

const modeOptions = (mode, selectable) => ({ mode, selectable })

export default function determinePpfNightMode(camera, isImperial) {
  const irRange = path(['model', 'infrared'], camera)
  const superLowLight = path(['model', 'superLowLight'], camera)
  const distance = convertUnitToMap({ isImperial, value: camera.distance })

  if (!camera.model) return modeOptions('infrared', ['infrared', 'superLowLight', 'conventional'])
  if (superLowLight && irRange) return modeOptions('infrared', ['infrared', 'superLowLight'])
  if (superLowLight) return modeOptions('superLowLight', ['superLowLight'])
  if (irRange && distance <= irRange) return modeOptions('infrared', ['infrared'])

  return modeOptions('conventional', ['conventional'])
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/determinePpfNightMode.js